import { IconArrowLeft, IconDownload, IconMaximize, IconCopy } from '@tabler/icons-react';

interface FundModalProps {
  isOpen: boolean;
  onClose: () => void;
  availableBalance: number;
  onFund?: (data: {
    address: string;
    network: string;
    amount: number;
  }) => void;
}

export default function FundModal({
  isOpen,
  onClose,
  availableBalance,
  onFund,
}: FundModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-0 md:p-4">
      <div className="relative w-full h-full md:h-auto md:max-h-[85vh] md:w-[480px] bg-background rounded-none md:rounded-xl overflow-hidden shadow-lg ring-1 ring-surface/5">
        {/* Header */}
        <div className="sticky top-0 z-10 flex items-center justify-between px-4 md:px-6 py-4 border-b border-surface bg-background/80 backdrop-blur-sm">
          <button
            type="button"
            onClick={onClose}
            className="p-2 -ml-2 text-text-secondary hover:text-white rounded-lg transition-colors"
            aria-label="Go back"
          >
            <IconArrowLeft size={24} />
          </button>
          <h1 className="text-xl font-semibold text-white">Fund Wallet</h1>
          <div className="w-10" /> {/* Spacer for alignment */}
        </div>

        {/* Coming Soon Content */}
        <div className="flex flex-col items-center justify-center h-[calc(100%-144px)] md:h-[400px] p-6">
          <div className="w-full max-w-md bg-surface/10 rounded-2xl p-8">
            <div className="flex flex-col items-center text-center space-y-6">
              <div className="w-20 h-20 rounded-full bg-surface flex items-center justify-center">
                <IconDownload size={36} className="text-primary" />
              </div>
              <div className="space-y-3">
                <h2 className="text-2xl font-semibold text-white">Coming Soon</h2>
                <p className="text-text-secondary">
                  The ability to fund your wallet directly from this app is coming soon. 
                  We're working hard to bring you this feature in the next update.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 left-0 right-0 p-4 md:p-6 bg-background/80 backdrop-blur-sm border-t border-surface">
          <div className="max-w-md mx-auto">
            <button
              type="button"
              onClick={onClose}
              className="w-full bg-surface text-white font-medium px-6 md:px-8 py-3 rounded-lg hover:bg-surface/80 transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}